import React, { useLayoutEffect, useEffect, useState } from 'react';
import { Alert, IconButton } from '@mui/material';
import { IoClose } from 'react-icons/io5'; // Close icon from react-icons
import './CustomAlert.css';

const CustomAlert = ({ message, type, onClose }) => {
    const [show, setShow] = useState(false);

    useLayoutEffect(() => {
        setTimeout(() => setShow(true), 10);
    }, []);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(false);
            setTimeout(onClose, 500);
        }, 5000);

        return () => {
            clearTimeout(timer);
        };
    }, [onClose]);

    const handleCloseClick = () => {
        setShow(false);
        setTimeout(onClose, 500);
    };

    return (
        <div className={`custom-alert-container ${show ? 'show' : ''}`}>
            <Alert
                severity={type}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        size="small"
                        onClick={handleCloseClick}
                    >
                        <IoClose />
                    </IconButton>
                }
            >
                {message}
            </Alert>
        </div>
    );
};

export default CustomAlert;
